import { zodResolver } from '@hookform/resolvers/zod';
import { Address } from '@pelicargo/types';
import { useEffect } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

type UseRequestForm = { methods: UseFormReturn<Address> };
type Options = { isCreate: boolean };

const defaultOptions = { isCreate: false };

const validationSchema = z.object({
  recipient: z.string().nullish(),
  line_one: z.string().nullish(),
  line_two: z.string().nullish(),
  city: z.string().nullish(),
  state: z.string().nullish(),
  zip_code: z.string().nullish(),
  country: z.string().nullish(),
});
const blankCargoOrigin: Partial<Address> = {
  recipient: undefined,
  line_one: undefined,
  line_two: undefined,
  country: undefined,
  state: undefined,
  city: undefined,
  zip_code: undefined,
};

export const formatCargoOrigin = (data: Partial<Address>, previousData?: Partial<Address>) => ({
  ...blankCargoOrigin,
  ...previousData,
  ...data,
});

export const useCargoOriginForm = (data?: Partial<Address>, { isCreate }: Options = defaultOptions): UseRequestForm => {
  const { reset, getValues, setValue, ...methods } = useForm<Address>({
    mode: 'onBlur',
    resolver: zodResolver(validationSchema),
    defaultValues: data,
  });

  useEffect(() => {
    const updateFields = () => {
      const incomingData = formatCargoOrigin(data, getValues());
      Object.keys(incomingData).map((key) => setValue<any>(key, incomingData[key]));
    };

    // Run if we're not on create & we have data
    if (!isCreate && data) updateFields();
  }, [data, reset, getValues, setValue, isCreate]);

  return { methods: { ...methods, getValues, setValue, reset } };
};
